import React, { useEffect, useRef, useState } from "react";
import HeroHeader from "./HeroHeader";
import NavButtons from "./NavButtons";
import CardSection from "./CardSection";
import RecruiterAiPopular from "./RecruiterAiPopular";
import RecruiterCard from "./RecruiterCard";
import OpportunitiesCard from "./OpportunitiesCard";
import PhoneSystemCard from "./PhoneSystemCard";
import BrivityLeadsCard from "./BrivityLeadsCard";
import BrivityVaCard from "./BrivityVaCard";
import ForwardCoachingCard from "./ForwardCoachingCard";
import BrivityLeadsPopular from "./BrivityLeadsPopular";

const NAV_OPTIONS = ["Popular", "Tech", "Services", "Integrations"];

const AddOns = () => {
  const [config, setConfig] = useState({
    selectedOption: "Popular",
    scroll: false,
  });
  const rootRef = useRef(null);
  const popularRef = useRef(null);
  const techRef = useRef(null);
  const servicesRef = useRef(null);
  const integrationsRef = useRef(null);

  useEffect(() => {
    const refreshCTA = () => {
      window.hubspot_web_interactives_running = false;
      const CTArefresh = document.createElement("script");
      CTArefresh.src = "https://js.hubspot.com/web-interactives-embed.js";
      document.body.appendChild(CTArefresh);
    };
    if (window.HubSpotCallsToActions) {
      refreshCTA();
    } else {
      window.hsCallsToActionsReady = [refreshCTA];
    }
  }, []);

  useEffect(() => {
    const refs = [
      { ref: popularRef, option: "Popular" },
      { ref: techRef, option: "Tech" },
      { ref: servicesRef, option: "Services" },
      { ref: integrationsRef, option: "Integrations" },
    ];

    const observer = new IntersectionObserver(
      (entries) => {
        // Find the entry with the largest intersection ratio
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visible) {
          const found = refs.find((r) => r.ref.current === visible.target);
          if (found && config.selectedOption !== found.option) {
            setConfig({ selectedOption: found.option });
          }
        }
      },
      { root: rootRef.current, threshold: [0, 0.5, 1] },
    );

    refs.forEach(({ ref }) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  }, [config.selectedOption]);

  useEffect(() => {
    if (!config.scroll) return;
    const verticalOffset = 100;
    const behavior = "smooth";
    if (config.selectedOption === "Popular") {
      rootRef.current.scrollTo({ top: popularRef.current.offsetTop - verticalOffset, behavior });
    }
    if (config.selectedOption === "Tech") {
      rootRef.current.scrollTo({ top: techRef.current.offsetTop - verticalOffset, behavior });
    }
    if (config.selectedOption === "Services") {
      rootRef.current.scrollTo({ top: servicesRef.current.offsetTop - verticalOffset, behavior });
    }
    if (config.selectedOption === "Integrations") {
      rootRef.current.scrollTo({ top: integrationsRef.current.offsetTop - verticalOffset, behavior });
    }
  }, [config]);

  return (
    <div
      className="tw-flex tw-flex-col tw-gap-[64px] tw-max-h-full tw-overflow-auto tw-pb-[64px]"
      ref={rootRef}
    >
      <HeroHeader />

      <NavButtons
        options={NAV_OPTIONS}
        value={config.selectedOption}
        onChange={(selectedOption) => setConfig({ selectedOption, scroll: true })}
      />

      <CardSection title="Popular" ref={popularRef}>
        <RecruiterAiPopular />
        <BrivityLeadsPopular />
      </CardSection>
      <CardSection title="Tech Enhancements" ref={techRef}>
        <RecruiterCard />
        <OpportunitiesCard />
        <PhoneSystemCard />
      </CardSection>
      <CardSection title="Brivity Services" ref={servicesRef}>
        <BrivityLeadsCard />
        <BrivityVaCard />
        <ForwardCoachingCard />
      </CardSection>
      <CardSection title="Integrations" ref={integrationsRef} />
    </div>
  );
};

export default AddOns;
